"use strict";

var staggerAnimation = function staggerAnimation() {
  var animations = document.querySelectorAll('[data-stagger-animation]');

  for (var i = 0; i < animations.length; i += 1) {
    var children = animations[i].children;
    var animationName = animations[i].getAttribute('data-stagger-animation');
    var animationDuration = animations[i].getAttribute('data-stagger-duration');

    for (var j = 0; j < children.length; j += 1) {
      children[j].setAttribute('data-animate-duration', animationDuration);
      children[j].setAttribute('data-animate', animationName);
      children[j].setAttribute('data-animate-delay', (j + 1) * 0.1);
    }
  }
};

var setAnimation = function setAnimation(animation, name, duration, delay) {
  animation.className = animation.className.replace('isInvisible', 'isVisible');
  animation.classList.add(name);
  animation.style.animationDuration = duration;
  animation.style.animationDelay = delay;
};

var animateOnScroll = function animateOnScroll() {
  staggerAnimation();
  var animations = document.querySelectorAll('[data-animate]'); // Average screen size

  var scrollSize = 720;

  var _loop = function _loop(i) {
    var offsetTop = animations[i].getBoundingClientRect().top;
    var animationName = animations[i].getAttribute('data-animate');
    var animationDuration = "".concat(animations[i].getAttribute('data-animate-duration'), "s");
    var animationDelay = "".concat(animations[i].getAttribute('data-animate-delay'), "s");
    var parent = animations[i].parentNode;
    animations[i].classList.add('isInvisible');

    if (offsetTop <= scrollSize) {
      setAnimation(animations[i], animationName, animationDuration, animationDelay);
    } else if (animations[i].hasAttribute('data-animate-in-element')) {
      scrollSize = 150;
      offsetTop = animations[i].getBoundingClientRect().top - parent.getBoundingClientRect().top;
      parent.addEventListener('scroll', function () {
        var containerOffset = parent.scrollTop + scrollSize;

        if (offsetTop < containerOffset) {
          setAnimation(animations[i], animationName, animationDuration, animationDelay);
        } else if (parent.scrollTop === parent.scrollHeight - parent.offsetHeight) {
          // If at bottom of element, apply animation
          setAnimation(animations[i], animationName, animationDuration, animationDelay);
        }
      });
    } else {
      window.addEventListener('scroll', function () {
        scrollSize = 1000;
        var pageOffset = window.pageYOffset + scrollSize;

        if (offsetTop < pageOffset) {
          setAnimation(animations[i], animationName, animationDuration, animationDelay);
        } else if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2) {
          setAnimation(animations[i], animationName, animationDuration, animationDelay);
        }
      });
    }
  };

  for (var i = 0; i < animations.length; i += 1) {
    _loop(i);
  }
};

animateOnScroll();